(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9895,7663,1333],{

/***/ 36779:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage/motorcycle-storage",
      function () {
        return __webpack_require__(66581);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



var PopularLocations = function(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "convenient-locations",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "section-heading",
                    children: props === null || props === void 0 ? void 0 : props.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "location-cards",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row justify-content-center g-3",
                        children: (props === null || props === void 0 ? void 0 : props.popularLocationsData) && (props === null || props === void 0 ? void 0 : (ref = props.popularLocationsData) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-xl-4 col-lg-4 col-md-6 col-sm-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "card sv-location-card",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                sizes: "(max-width: 375px) 300px, (max-width: 576px) 540px, (max-width: 768px) 355px, (max-width: 992px) 310px, (max-width: 1280px) 370px",
                                                src: item === null || item === void 0 ? void 0 : (ref = item.Thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url,
                                                priority: true,
                                                className: "card-img-top",
                                                alt: (item === null || item === void 0 ? void 0 : (ref3 = item.Thumbnail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.alternativeText) || (item === null || item === void 0 ? void 0 : (ref6 = item.Thumbnail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.name),
                                                width: "350",
                                                height: "175"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "card-body",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    className: "location-name",
                                                    children: item === null || item === void 0 ? void 0 : item.Title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: (item === null || item === void 0 ? void 0 : item.Link_Slug_or_URL) || "",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "text-decoration-none",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "primary-card-btn",
                                                            children: item === null || item === void 0 ? void 0 : item.Link_Text
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        }))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopularLocations);


/***/ }),

/***/ 90323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90395);
/* harmony import */ var _helper_wordReplace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27147);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13135);





var Accordions = function(param) {
    var title = param.title, content = param.content, index = param.index, siteUrl = param.siteUrl;
    var brand = _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_TITLE */ .jG;
    var brandUrl = siteUrl ? "https://".concat(siteUrl) : _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_URL */ ._O;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        defaultActiveKey: "0",
        className: "sv-accordion mb-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Item */ .Z.Item, {
            eventKey: index,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Header */ .Z.Header, {
                    children: (0,_helper_wordReplace__WEBPACK_IMPORTED_MODULE_2__/* .replaceWithRequiredSiteInfo */ .u2)(brand, brandUrl, title)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "card-content",
                        dangerouslySetInnerHTML: {
                            __html: (0,_helper_wordReplace__WEBPACK_IMPORTED_MODULE_2__/* .replaceWithRequiredSiteInfo */ .u2)(brand, brandUrl, content)
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordions);


/***/ }),

/***/ 41333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ safe_storage_solutions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/helper/wordReplace.tsx
var wordReplace = __webpack_require__(27147);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/components/home-content/storage-solution-card.tsx






// The title, description and link on the left and image on the right
// The description is hidden on phone device
var StorageSolutionCard = function(props) {
    var card = props.card, hostUrl = props.hostUrl;
    var Title = card.Title, Description = card.Description, Thumbnail = card.Thumbnail;
    var linkText = card && card.Link_Text;
    var linkUrl = card && card.Link_Slug_or_URL ? card.Link_Slug_or_URL : "";
    var urlImg = Thumbnail && Thumbnail.data && Thumbnail.data.attributes && Thumbnail.data.attributes.url;
    var urlImgAlt = Thumbnail && Thumbnail.data && Thumbnail.data.attributes && Thumbnail.data.attributes.alternativeText;
    var brandUrl = hostUrl ? "https://".concat(hostUrl) : constants/* SITE_URL */._O;
    var brandTitle = constants/* SITE_TITLE */.jG;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-xl-4 col-lg-4 col-md-6 col-sm-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "card sv-solution-card mb-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-body p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row g-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-xl-8 col-lg-8 col-md-8 col-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "card-body-padding",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "card-title",
                                            children: Title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "card-text",
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize((0,wordReplace/* replaceWithRequiredSiteInfo */.u2)(brandTitle, brandUrl, Description))
                                            }
                                        })
                                    ]
                                }),
                                linkText && linkUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card-footer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,wordReplace/* replaceWithRequiredSiteInfo */.u2)(brandTitle, brandUrl, linkUrl) || "",
                                        className: "card-link link mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "card-link link",
                                            children: linkText
                                        })
                                    })
                                })
                            ]
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xl-4 col-lg-4 col-md-4 col-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: urlImg,
                                sizes: "(max-width: 375px) 95px, (max-width: 576px) 135px, (max-width: 768px) 140px, (max-width: 992px) 125px, (max-width: 1280px) 145px",
                                className: "card-img",
                                alt: urlImgAlt || "location-img",
                                width: "145",
                                height: "155"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var storage_solution_card = (StorageSolutionCard);

;// CONCATENATED MODULE: ./src/components/home-content/safe-storage-solutions.tsx


var SafeStorageSolutions = function(props) {
    var title = props.title, cards = props.cards, hostUrl = props.hostUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "safe-storage sv-safe-storage-responsive sv-safe-car-storage",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "section-heading",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "solution-cards",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center g-3",
                        children: cards && cards.map(function(card) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(storage_solution_card, {
                                card: card,
                                hostUrl: hostUrl
                            }, card.id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var safe_storage_solutions = (SafeStorageSolutions);


/***/ }),

/***/ 37663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _helper_wordReplace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27147);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13135);






var RightStore = function(props) {
    var title = props === null || props === void 0 ? void 0 : props.teamTitle;
    var data = props === null || props === void 0 ? void 0 : props.teamData;
    var hostUrl = props.hostUrl;
    var brandUrl = hostUrl ? "https://".concat(hostUrl) : _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .SITE_URL */ ._O;
    var brandTitle = _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .SITE_TITLE */ .jG;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "sv-team-details my-4 my-lg-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "section-heading",
                    children: title
                }),
                data && (data === null || data === void 0 ? void 0 : data.length) && (data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row align-items-center mb-4 sv-team-reverse-columns",
                        children: [
                            index % 2 === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    sizes: "(max-width: 375px) 300px, (max-width: 576px) 540px, (max-width: 768px) 355px, (max-width: 992px) 475px, (max-width: 1280px) 560px",
                                    src: item === null || item === void 0 ? void 0 : (ref = item.Thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url,
                                    className: "w-100 img-fluid team-img",
                                    alt: (item === null || item === void 0 ? void 0 : (ref3 = item.Thumbnail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.alternativeText) || (item === null || item === void 0 ? void 0 : (ref6 = item.Thumbnail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.name),
                                    width: "472",
                                    height: "275"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sv-our-team-content",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: item === null || item === void 0 ? void 0 : item.Title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize((0,_helper_wordReplace__WEBPACK_IMPORTED_MODULE_4__/* .replaceWithRequiredSiteInfo */ .u2)(brandTitle, brandUrl, item === null || item === void 0 ? void 0 : item.Description))
                                            }
                                        })
                                    ]
                                })
                            }),
                            index % 2 === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    sizes: "(max-width: 375px) 300px, (max-width: 576px) 540px, (max-width: 768px) 355px, (max-width: 992px) 475px, (max-width: 1280px) 560px",
                                    src: item === null || item === void 0 ? void 0 : (ref9 = item.Thumbnail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.url,
                                    className: "w-100 img-fluid team-img",
                                    alt: (item === null || item === void 0 ? void 0 : (ref12 = item.Thumbnail) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : ref14.alternativeText) || (item === null || item === void 0 ? void 0 : (ref15 = item.Thumbnail) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.attributes) === null || ref17 === void 0 ? void 0 : ref17.name),
                                    width: "472",
                                    height: "275"
                                })
                            })
                        ]
                    }, index);
                }))
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RightStore);


/***/ }),

/***/ 11362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13135);
/* harmony import */ var _faqs_accordian__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90323);
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55088);





var FAQValet = function(props) {
    var ref, ref1;
    var faqTitle = props === null || props === void 0 ? void 0 : props.title;
    var faqData = props === null || props === void 0 ? void 0 : props.data;
    var brand = _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_TITLE */ .jG;
    var brandUrl = (props === null || props === void 0 ? void 0 : props.hostUrl) ? "https://".concat(props === null || props === void 0 ? void 0 : props.hostUrl) : _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    var isFaqInfo = !((props === null || props === void 0 ? void 0 : props.data) && ((ref = props === null || props === void 0 ? void 0 : props.data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Title));
    var faqStructuredData = faqData && (0,_utility__WEBPACK_IMPORTED_MODULE_4__/* .generateDynamicFAQ */ .a4)(faqData, isFaqInfo, brand, brandUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .FAQPageJsonLd */ .Mg, {
                mainEntity: faqStructuredData
            }),
            faqData && faqData.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "FAQ-section",
                id: "faq",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "section-heading",
                            children: faqTitle
                        }),
                        faqData && faqData.length && faqData.map(function(item, index) {
                            var ref, ref1, ref2;
                            var title = (item === null || item === void 0 ? void 0 : item.Title) ? item.Title : item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.Title;
                            var brandData = item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : ref1.Brands;
                            var description = (item === null || item === void 0 ? void 0 : item.Description) ? item.Description : item === null || item === void 0 ? void 0 : (ref2 = item.attributes) === null || ref2 === void 0 ? void 0 : ref2.Content;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_faqs_accordian__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    title: title,
                                    content: description,
                                    index: index,
                                    randData: brandData,
                                    className: "sv-accordion mb-4",
                                    siteUrl: props === null || props === void 0 ? void 0 : props.hostUrl
                                })
                            }, index);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQValet);


/***/ }),

/***/ 66581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Canonical__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83664);
/* harmony import */ var _components_convenient_locations_popular_locations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57445);
/* harmony import */ var _components_hero_banner_hero_storesearch_banner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60095);
/* harmony import */ var _components_home_content_safe_storage_solutions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41333);
/* harmony import */ var _components_self_storage_residential_right_store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37663);
/* harmony import */ var _components_utility__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55088);
/* harmony import */ var _components_valet_service_faqValet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11362);
/* harmony import */ var _context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2621);
/* harmony import */ var _services_home_setBrands__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76784);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13135);


















var TitleDescriptionComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 1115).then(__webpack_require__.bind(__webpack_require__, 51115));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51115)
            ];
        }
    }
});
var ClientReviews = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7436).then(__webpack_require__.bind(__webpack_require__, 97436));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97436)
            ];
        }
    }
});
var MotorStore = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43;
    var headerFooterData = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP);
    var headerFooter = headerFooterData.headerFooter;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var getContextData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
            var defaultBrand, contextData, brands;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .BRAND_NAME_EN */ .Vp;
                        if (locale === "fr") defaultBrand = _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .BRAND_NAME_FR */ .Fj;
                        return [
                            4,
                            (0,_services_home_setBrands__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    var teamTitle = (ref2 = props === null || props === void 0 ? void 0 : (ref = props.MotorStoreData) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Section[4]) === null || ref2 === void 0 ? void 0 : ref2.Title;
    var teamData = (ref5 = props === null || props === void 0 ? void 0 : (ref3 = props.MotorStoreData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.Section[5]) === null || ref5 === void 0 ? void 0 : ref5.Cards;
    var faqTitle = (ref8 = props === null || props === void 0 ? void 0 : (ref6 = props.MotorStoreData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.Section[6]) === null || ref8 === void 0 ? void 0 : ref8.Title;
    var faqData = (ref11 = props === null || props === void 0 ? void 0 : (ref9 = props.MotorStoreData) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.Section[6]) === null || ref11 === void 0 ? void 0 : ref11.Panel;
    var carTitle = (ref14 = props === null || props === void 0 ? void 0 : (ref12 = props.MotorStoreData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : ref13.Section[2]) === null || ref14 === void 0 ? void 0 : ref14.Title;
    var carData = (ref17 = props === null || props === void 0 ? void 0 : (ref15 = props.MotorStoreData) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.attributes) === null || ref16 === void 0 ? void 0 : ref16.Section[3]) === null || ref17 === void 0 ? void 0 : ref17.Cards;
    var popularTitle = (ref20 = props === null || props === void 0 ? void 0 : (ref18 = props.MotorStoreData) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.attributes) === null || ref19 === void 0 ? void 0 : ref19.Section[7]) === null || ref20 === void 0 ? void 0 : ref20.Title;
    var popularData = (ref23 = props === null || props === void 0 ? void 0 : (ref21 = props.MotorStoreData) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.attributes) === null || ref22 === void 0 ? void 0 : ref22.Section[8]) === null || ref23 === void 0 ? void 0 : ref23.Cards;
    var stagingTitle = (ref26 = props === null || props === void 0 ? void 0 : (ref24 = props.MotorStoreData) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.attributes) === null || ref25 === void 0 ? void 0 : ref25.Section[9]) === null || ref26 === void 0 ? void 0 : ref26.Title;
    var stagingDesc = (ref29 = props === null || props === void 0 ? void 0 : (ref27 = props.MotorStoreData) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.attributes) === null || ref28 === void 0 ? void 0 : ref28.Section[9]) === null || ref29 === void 0 ? void 0 : ref29.Description;
    var stagingTitlee = (ref32 = props === null || props === void 0 ? void 0 : (ref30 = props.MotorStoreData) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.attributes) === null || ref31 === void 0 ? void 0 : ref31.Section[10]) === null || ref32 === void 0 ? void 0 : ref32.Title;
    var stagingDescc = (ref35 = props === null || props === void 0 ? void 0 : (ref33 = props.MotorStoreData) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.attributes) === null || ref34 === void 0 ? void 0 : ref34.Section[10]) === null || ref35 === void 0 ? void 0 : ref35.Description;
    var stagingTitleee = (ref38 = props === null || props === void 0 ? void 0 : (ref36 = props.MotorStoreData) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.attributes) === null || ref37 === void 0 ? void 0 : ref37.Section[11]) === null || ref38 === void 0 ? void 0 : ref38.Title;
    var stagingDesccc = (ref41 = props === null || props === void 0 ? void 0 : (ref39 = props.MotorStoreData) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.attributes) === null || ref40 === void 0 ? void 0 : ref40.Section[11]) === null || ref41 === void 0 ? void 0 : ref41.Description;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var seoProps = (0,_components_utility__WEBPACK_IMPORTED_MODULE_10__/* .getSEOProps */ .RN)(props === null || props === void 0 ? void 0 : (ref42 = props.MotorStoreData) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.attributes) === null || ref43 === void 0 ? void 0 : ref43.SEO, router);
    var hostUrl = props.hostUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, seoProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Canonical__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hero_banner_hero_storesearch_banner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBread: true,
                cmsData: props === null || props === void 0 ? void 0 : props.MotorStoreData,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_content_safe_storage_solutions__WEBPACK_IMPORTED_MODULE_8__["default"], {
                title: carTitle,
                cards: carData,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_self_storage_residential_right_store__WEBPACK_IMPORTED_MODULE_9__["default"], {
                teamTitle: teamTitle,
                teamData: teamData,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_valet_service_faqValet__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                data: faqData,
                title: faqTitle,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClientReviews, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_convenient_locations_popular_locations__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: popularTitle,
                popularLocationsData: popularData,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleDescriptionComponent, {
                isBread: false,
                title: stagingTitle,
                description: stagingDesc,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleDescriptionComponent, {
                isBread: false,
                title: stagingTitlee,
                description: stagingDescc,
                hostUrl: hostUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleDescriptionComponent, {
                isBread: false,
                title: stagingTitleee,
                description: stagingDesccc,
                hostUrl: hostUrl
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (MotorStore);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1217,1608,9238,1664,4585,8837,395,3640,8909,9774,2888,179], function() { return __webpack_exec__(36779); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);